import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { itemDataType } from "./ResolveDetails";
import { Button } from "../../../../../../stories/Button/Button";
import { Form, Formik, FormikProps } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { LabelProps } from "../../../../../../utils/types";
import InputHoc from "../../../../../common/Input/Index";
import { IObjectKeys } from "../../../../../../utils/formTypes";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AddStckRetrieItemDetailsResult,
  AddStckRetrieItemDetailsVar,
  AtsStckRetireItemDetailsEdge,
  AtsStckRetireItemDetailsOrderField,
  GetRetiredItemDetailsResult,
  GetRetiredItemDetailsVar,
} from "../types";
import { AddStckRetrieItemDetails } from "../mutations";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import {
  FETCH_MORE_DATA,
  emptyMessage,
} from "../../../../../../utils/constants";
import { Operation } from "../../../../../../utils/Enum.types";
import MessageModal from "../../../../../../customComponents/MessageModal";
import {
  getModifiedScrollHeight,
  toIsoDate,
  toStandardDate,
  toStandardDateAndTime,
} from "../../../../../../utils/UtilFunctions";
import useServerDateandTimeWithoutToken from "../../../../../../customHooks/useServerDateandTimeWithoutToken";
import { AppContext } from "../../../../../../context/context";
import { GetRetiredItemDetails } from "../queries";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import { CustomDrawerOldData } from "../../../../../../styles/CustomDrawerStyles";
import ViewAssetDetails from "../../../maps/ticketing/raisedtickets/ViewAssetDetails";
import { TableType } from "../../../../customer/companies/queries/types";
import JunctionDetails from "../../../maps/ticketing/junctionDetails/JunctionDetails";

interface Props {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  itemData: itemDataType;
  ticketId: number;
}

const details = [
  {
    labelName: "Serial Number",
    inputName: "slNo",
    dataType: "text",
    autoFocus: true,
  },
  {
    labelName: "Batch",
    inputName: "prodBatchNo",
    dataType: "text",
  },
  {
    labelName: "Warranty Start Date",
    inputName: "prodWarrantyStartDate",
    dataType: "date",
  },
  {
    labelName: "Warranty End Date",
    inputName: "prodWarrantyEndDate",
    dataType: "date",
  },
  {
    labelName: "Installation Date",
    inputName: "prodInstallationEndDate",
    dataType: "date",
  },
  {
    labelName: "Geo Location",
    inputName: "siteLocation",
    dataType: "text",
  },
];

const intialFormData = {
  slNo: "",
  prodSerialNo: "",
  maintainedBy: "",
  prodBatchNo: "",
  prodInstallationEndDate: "",
  prodWarrantyEndDate: "",
  prodWarrantyStartDate: "",
  siteLocation: "",
};

interface formDataType extends IObjectKeys {
  slNo: string;
  prodBatchNo: string;
  prodInstallationEndDate: string;
  prodWarrantyEndDate: string;
  prodWarrantyStartDate: string;
  siteLocation: string;
}

const ReplaceStock = ({ setOpenModal, itemData, ticketId }: Props) => {
  const [formData, setFormData] = useState<formDataType>(intialFormData);
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const [message, setMessage] = useState(emptyMessage);
  const { data: serverDate } = useServerDateandTimeWithoutToken();
  const [itemDetails, setItemDetails] = useState<
    AtsStckRetireItemDetailsEdge[]
  >([]);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [assetDetailsModal, setAssetDetailsModal] = useState(false);
  const [itemDetailId, setItemDetailId] = useState(0);

  const [addStckRetrieItemDetails] = useMutation<
    AddStckRetrieItemDetailsResult,
    AddStckRetrieItemDetailsVar
  >(AddStckRetrieItemDetails, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [getRetiredItemDetails, { data, loading, fetchMore }] = useLazyQuery<
    GetRetiredItemDetailsResult,
    GetRetiredItemDetailsVar
  >(GetRetiredItemDetails);

  const handleSubmit = () => {
    if (customer_id && itemData.id && ticketId && formData)
      addStckRetrieItemDetails({
        variables: {
          customer_id,
          user_details,
          input: {
            retireDate: serverDate ? toIsoDate(serverDate.GetServerDateAndTimeWithoutToken) : "",
            prodSerialNo: formData.slNo,
            prodBatchNo: formData.prodBatchNo,
            prodWarrantyStartDate: formData.prodWarrantyStartDate
              ? toIsoDate(formData.prodWarrantyStartDate)
              : undefined,
            prodWarrantyEndDate: formData.prodWarrantyEndDate
              ? toIsoDate(formData.prodWarrantyEndDate)
              : undefined,
            prodInstallationEndDate: formData.prodInstallationEndDate
              ? toIsoDate(formData.prodInstallationEndDate)
              : undefined,
            prodLatitude: formData.siteLocation
              ? formData.siteLocation.split(",")[0]
              : "",
            prodLongitude: formData.siteLocation
              ? formData.siteLocation.split(",")[1]
              : "",
            itemId: 0,
            itemDetailsId: itemData.id,
            ticketId: ticketId,
            subsidiaryId: 0,
            siteId: 0,
            companyId: 0,
            junctionId: 0,
            ldgrId: 0,
          },
        },
        refetchQueries: [
          {
            query: GetRetiredItemDetails,
            variables: {
              customerID: customer_id,
              companyID: 0,
              subsidiaryID: 0,
              siteID: 0,
              junctionID: 0,
              ticketID: Number(ticketId),
              itemDetailsID: itemData.id ? Number(itemData.id) : 0,
              after: null,
              first: 25,
              orderBy: {
                direction: OrderDirection.DESC,
                field: AtsStckRetireItemDetailsOrderField.CREATED_AT,
              },
              name: "",
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.AddStckRetrieItemDetails) {
          setMessage({
            flag: true,
            message: "Updated Successfully",
            operation: Operation.UPDATE,
          });
        }
      });
  };

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<formDataType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };

  const handleClear = () => {
    setFormData(intialFormData);
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
      setOpenModal(false);
    }
    setMessage(emptyMessage);
  };

  useEffect(() => {
    if (customer_id && ticketId && itemData.id)
      getRetiredItemDetails({
        variables: {
          customerID: customer_id,
          companyID: 0,
          subsidiaryID: 0,
          siteID: 0,
          junctionID: 0,
          ticketID: Number(ticketId),
          itemDetailsID: itemData.id ? Number(itemData.id) : 0,
          after: null,
          first: 25,
          orderBy: {
            direction: OrderDirection.DESC,
            field: AtsStckRetireItemDetailsOrderField.CREATED_AT,
          },
          name: "",
        },
      });
  }, [getRetiredItemDetails, customer_id, ticketId, itemData.id]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetRetiredItemDetails.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCustomer) => {
          const filteredStudent = itemDetails.find(
            (ticket) => ticket.node.id === newCustomer.node.id
          );
          if (filteredStudent) {
            return {
              ...newCustomer,
              node: {
                ...newCustomer.node,
              },
            };
          }
          return newCustomer;
        });

        setItemDetails(updatedNewData);
      } else {
        setItemDetails(newData);
      }

      setEndCursor(data.GetRetiredItemDetails.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [loading, data]);

  const handleScroll = (e: Event) => {
    const target = e.target as HTMLDivElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;

    if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
      if (hasNextPage && !loading) {
        fetchMore({
          variables: {
            first: FETCH_MORE_DATA,
            after: endCursor,
          },
          updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) return prevResult;

            const newEdges = fetchMoreResult.GetRetiredItemDetails.edges;
            const pageInfo = fetchMoreResult.GetRetiredItemDetails.pageInfo;

            setEndCursor(pageInfo.endCursor);
            setHasNextPage(pageInfo.hasNextPage);

            const duplicateCheck = prevResult.GetRetiredItemDetails
              ? prevResult.GetRetiredItemDetails.edges.filter(
                  ({ node: { id } }) =>
                    newEdges.findIndex(
                      ({ node: { id: newId } }) => newId === id
                    ) !== -1
                )
              : [];

            if (duplicateCheck.length > 0) return prevResult;

            return {
              GetRetiredItemDetails: {
                edges: [...itemDetails, ...newEdges],
                pageInfo,
                totalCount: data ? data.GetRetiredItemDetails.totalCount! : 0,
              },
            };
          },
        });
      }
    }
  };

  return (
    <>
      <div className="replace-stock">
        <div className="replace-stock__title">
          <Title>Replace Stock</Title>
          <img src={Close} alt="" onClick={() => setOpenModal(false)} />
        </div>
        <div className="replace-stock__details">
          <JunctionDetails assetType={TableType.JUNCTION} viewIcon={true} />
          <div className="resolve-details__ul--li">
            <div className="resolve-details__ul--flex">
              <img src={itemData.img} alt="" />
              <div>
                <b>{itemData.desc}</b>
                <div className="resolve-details__ul--block">
                  <b className="font-blue">{itemData.slNo}</b>
                  <span className="font-grey"> Pole {itemData.poleNum}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Formik
          initialValues={formData}
          onSubmit={handleSubmit}
          enableReinitialize
          validateOnChange
        >
          {(meta) => {
            return (
              <Form className="replace-stock__form">
                <div className="replace-stock__block">
                  <div className="replace-stock__block--left">
                    <b>Existing Product Information</b>
                    <ul>
                      <li>
                        <span>Serial Number</span> <span>:</span>
                        <b>{itemData.prodSerialNo}</b>
                      </li>
                      <li>
                        <span>Batch</span> <span>:</span>
                        <b>{itemData.prodBatchNo}</b>
                      </li>
                      <li>
                        <span>Warranty Start Date</span> <span>:</span>
                        <b>{toStandardDate(itemData.prodWarrantyStartDate)}</b>
                      </li>
                      <li>
                        <span>Warranty End Date</span> <span>:</span>
                        <b>{toStandardDate(itemData.prodWarrantyEndDate)}</b>
                      </li>

                      <li>
                        <span>Maintained By</span> <span>:</span>{" "}
                        <b>{itemData.maintainedBy}</b>
                      </li>

                      <li>
                        <span>Geo Location</span> <span>:</span>{" "}
                        <b>{itemData.siteLocation}</b>
                      </li>

                      <li>
                        <span>Installation Date & Time</span> <span>:</span>{" "}
                        <b>{itemData.prodInstallationEndDate}</b>
                      </li>
                    </ul>
                    <div className="replace-stock__block--left--history">
                      <b>Replaced History</b>
                      <div className="replace-stock__block--left--history--list">
                        {itemDetails &&
                          itemDetails.map(({ node }, index) => {
                            return (
                              <div
                                key={index}
                                onClick={() => {
                                  setAssetDetailsModal(true);
                                  setItemDetailId(node.id);
                                }}
                                className="replace-stock__block--left--history--item"
                              >
                                <div className="replace-stock__block--left--history--flex">
                                  {index + 1}.&nbsp;
                                  <span>{node.prodSerialNo}</span>
                                </div>
                                <div className="replace-stock__block--left--history--flex">
                              
                                  {toStandardDateAndTime(node.retireDate)}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                  <div className="replace-stock__block--right">
                    <b>New Product Information</b>
                    {details.map((field: LabelProps, key: React.Key) => {
                      return (
                        <React.Fragment key={key}>
                          <InputHoc
                            LabelName={field.labelName}
                            values={formData[field.inputName]}
                            name={field.inputName}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              handleValueChange(e, meta);
                            }}
                            required={field.required}
                            autoFocus={field.autoFocus}
                            type={field.dataType}
                            onBlur={meta.handleBlur}
                            onKeyDown={onkeydown}
                          />
                          {meta.touched[field.inputName] &&
                          meta.errors[field.inputName] ? (
                            <div className="label-grid">
                              <span />
                              <span className="nodata">
                                {meta.errors[field.inputName]}
                              </span>
                            </div>
                          ) : null}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>

                <Button type="submit" mode="save" className="submit" />
                <Button
                  mode="clear"
                  type="button"
                  onClick={() => handleClear()}
                />
                <Button
                  mode="cancel"
                  type="button"
                  onClick={() => setOpenModal(false)}
                />
              </Form>
            );
          }}
        </Formik>
      </div>

      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />

      <CustomDrawerOldData
        anchor="right"
        open={assetDetailsModal}
        onClose={() => setAssetDetailsModal(!assetDetailsModal)}
      >
        <ViewAssetDetails
          setModalFlag={setAssetDetailsModal}
          itemId={0}
          itemRetireId={itemDetailId}
        />
      </CustomDrawerOldData>
    </>
  );
};

export default ReplaceStock;
